import type { ContestType } from '@betterpool/api-types/contests-service';

export const isContestTeamBased = (contestType: ContestType) => contestType?.startsWith('team');
export const isContestPlayerBased = (contestType: ContestType) => contestType?.startsWith('player');
